import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { BookIcon } from 'app/components/shared/icons';

import { IDataTypeData } from '../../../PublicationContent';
import './styled';
import {
  DataTypeArticleIconContainer,
  DataTypeArticlePillText,
  DataTypeArticlePillWrapper,
} from './styled';

export const dataTypeArticleContentModifier = (
  node: HTMLDivElement,
  push: (location: any, state?: any) => void,
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>
) => {
  node.querySelectorAll('[data-type="articles"], [data-type="article"]').forEach((article) => {
    const slug = article.getAttribute('data-slug');
    const name = article.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeArticlePill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDataTypeData({
        slug,
        type: 'articles',
      });
      push(`/articles/${slug}`);
    });

    article.replaceWith(template.firstChild);
  });
};

interface DataTypeArticlePillProps {
  name: string;
}

export const DataTypeArticlePill = ({ name }: DataTypeArticlePillProps) => {
  return (
    <DataTypeArticlePillWrapper>
      <DataTypeArticleIconContainer>
        <BookIcon width={16} height={16} fill={'var(--color-primary)'} />
      </DataTypeArticleIconContainer>
      <DataTypeArticlePillText>{name}</DataTypeArticlePillText>
    </DataTypeArticlePillWrapper>
  );
};
